/* Bearfit Forge — theme.js */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var debounce = function (fn, wait) {
    var t; return function () { var args = arguments, self = this; clearTimeout(t); t = setTimeout(function () { fn.apply(self, args); }, wait); };
  };
  var storage = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  };

  /* ------------------------------------------------------------------
     Overlay / drawers
     ------------------------------------------------------------------ */
  var overlay = $('[data-overlay]');
  var activeDrawer = null;
  var lastFocus = null;

  function showOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    setTimeout(function () { if (!activeDrawer) overlay.hidden = true; }, 350);
  }

  /* Drawers/Suche liegen teils in Sections mit eigenem Stapelkontext (z. B. der
     fixierte Header mit z-index 30). Damit sie über dem Overlay (z-index 50)
     liegen und klickbar bleiben, wird die umgebende Section angehoben. */
  function raiseLayer(el, on) {
    var host = el && el.closest('.shopify-section');
    if (!host) return;
    clearTimeout(host._layerTimer);
    if (on) { host.style.zIndex = '70'; return; }
    host._layerTimer = setTimeout(function () {
      if (!host.querySelector('.drawer.is-open, .search-modal.is-open')) host.style.zIndex = '';
    }, 460);
  }

  function openDrawer(id, opts) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(true);
    lastFocus = document.activeElement;
    activeDrawer = drawer;
    if (opts && opts.instant) { drawer.style.transition = 'none'; }
    raiseLayer(drawer, true);
    drawer.classList.add('is-open');
    if (opts && opts.instant) { drawer.offsetHeight; drawer.style.transition = ''; }
    document.body.classList.add('is-locked');
    showOverlay();
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { drawer.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer(keepOverlay) {
    if (!activeDrawer) return;
    var id = activeDrawer.id;
    activeDrawer.classList.remove('is-open');
    raiseLayer(activeDrawer, false);
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    activeDrawer = null;
    if (!keepOverlay) {
      document.body.classList.remove('is-locked');
      hideOverlay();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-overlay]')) { closeDrawer(); closeSearch(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer(); closeSearch(); closePopup(); closeLightbox();
      $$('.header__menu-item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    }
  });

  /* Mobile submenus */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    var sub = toggle.nextElementSibling;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    if (sub) sub.classList.toggle('is-open', !open);
  });

  /* ------------------------------------------------------------------
     Header
     ------------------------------------------------------------------ */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var section = header.closest('.shopify-section') || header.parentElement;
    section.classList.add('section-header');
    var transparent = header.getAttribute('data-transparent') === 'true';
    var sticky = header.getAttribute('data-sticky');
    var announcement = $('.section-announcement');

    function setAnnouncementHeight() {
      var h = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
      var hh = header.querySelector('.header');
      if (hh) document.documentElement.style.setProperty('--header-height', hh.offsetHeight + 'px');
    }
    setAnnouncementHeight();
    window.addEventListener('resize', debounce(setAnnouncementHeight, 150));

    if (transparent) section.classList.add('is-transparent');
    if (sticky === 'none') { section.style.position = transparent ? 'absolute' : 'relative'; }

    var lastY = window.scrollY;
    function onScroll() {
      var y = window.scrollY;
      var threshold = announcement ? announcement.offsetHeight : 0;
      section.classList.toggle('is-scrolled', y > threshold + 4);
      if (sticky === 'scroll_up') {
        var hide = y > lastY && y > 300 && !section.classList.contains('is-open');
        section.classList.toggle('is-hidden', hide);
      }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mega menu: keep the header opaque while a dropdown is open */
    $$('[data-menu-item]', header).forEach(function (item) {
      var link = item.querySelector('.header__menu-link');
      var mega = item.querySelector('.mega');
      if (!mega) return;
      var closeTimer;
      function open() { clearTimeout(closeTimer); section.classList.add('is-open'); item.classList.add('is-open'); if (link) link.setAttribute('aria-expanded', 'true'); }
      function close() { closeTimer = setTimeout(function () { item.classList.remove('is-open'); if (link) link.setAttribute('aria-expanded', 'false'); if (!$('.header__menu-item.is-open', header)) section.classList.remove('is-open'); }, 80); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    });
  }

  /* ------------------------------------------------------------------
     Search (overlay + predictive)
     ------------------------------------------------------------------ */
  var searchModal = null;
  function openSearch() {
    searchModal = searchModal || $('#SearchModal');
    if (!searchModal) return;
    raiseLayer(searchModal, true);
    searchModal.classList.add('is-open');
    showOverlay();
    $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var input = $('input[type="search"]', searchModal);
    setTimeout(function () { if (input) input.focus(); }, 100);
  }
  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    raiseLayer(searchModal, false);
    $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!activeDrawer) hideOverlay();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  function initPredictiveSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || !theme.routes || !theme.routes.predictiveSearch) return;
    var controller;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.shopify-section');
          results.innerHTML = content ? content.innerHTML : '';
        })
        .catch(function () { /* aborted */ });
    }, 250));
  }

  /* ------------------------------------------------------------------
     Section rendering helpers
     ------------------------------------------------------------------ */
  function sectionIdOf(el) {
    var s = el && el.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function cartSectionIds() {
    var ids = [];
    if ($('[data-cart-drawer]')) ids.push('cart-drawer');
    var page = $('[data-cart-page]');
    if (page) { var id = sectionIdOf(page); if (id) ids.push(id); }
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
      if (!source) return;
      var wasOpen = !!target.querySelector('.drawer.is-open');
      target.innerHTML = source.innerHTML;
      if (wasOpen) {
        var drawer = target.querySelector('.drawer');
        if (drawer) { drawer.style.transition = 'none'; drawer.classList.add('is-open'); activeDrawer = drawer; drawer.offsetHeight; drawer.style.transition = ''; }
      }
    });
  }

  function updateCartCount(count) {
    $$('[data-cart-count], .header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0 && el.hasAttribute('data-cart-count'));
    });
  }

  function refreshCartCount() {
    return fetch((theme.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  /* ------------------------------------------------------------------
     Cart: add / change
     ------------------------------------------------------------------ */
  function addToCart(items, opts) {
    opts = opts || {};
    var ids = cartSectionIds();
    var body = { items: items };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { throw new Error(res.data.description || res.data.message || theme.strings.error); }
        if (theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) {
          window.location.href = theme.routes.cart;
          return res.data;
        }
        applySections(res.data.sections);
        return refreshCartCount().then(function () {
          if (!activeDrawer || activeDrawer.id !== 'CartDrawer') openDrawer('CartDrawer');
          return res.data;
        });
      });
  }

  function changeLine(line, quantity) {
    var ids = cartSectionIds();
    var container = $('[data-cart-drawer]') || $('[data-cart-page]');
    $$('.cart-items').forEach(function (el) { el.classList.add('is-updating'); });
    var body = { line: Number(line), quantity: Math.max(0, Number(quantity)) };
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) { throw new Error(cart.description || theme.strings.error); }
        applySections(cart.sections);
        updateCartCount(cart.item_count);
      })
      .catch(function (err) {
        $$('.cart-items').forEach(function (el) { el.classList.remove('is-updating'); });
        window.alert(err.message);
      });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { e.preventDefault(); changeLine(qtyBtn.getAttribute('data-line'), qtyBtn.getAttribute('data-cart-qty')); return; }

    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && theme.cartType === 'drawer' && $('#CartDrawer')) {
      e.preventDefault(); openDrawer('CartDrawer'); return;
    }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      addToCart([{ id: Number(quick.getAttribute('data-quick-add')), quantity: 1 }])
        .catch(function (err) { window.alert(err.message); })
        .then(function () { quick.disabled = false; });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (input) changeLine(input.getAttribute('data-line'), input.value);
  });

  /* ------------------------------------------------------------------
     Product page
     ------------------------------------------------------------------ */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    var picker = $('[data-variant-picker]', root);
    var variants = [];
    var json = $('[data-variants-json]', root);
    if (json) { try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; } }

    function selectedOptions() {
      return $$('.option', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    function updateAvailability(opts) {
      $$('.option', picker).forEach(function (fs, index) {
        $$('.option__value', fs).forEach(function (wrap) {
          var input = $('input', wrap);
          var test = opts.slice(); test[index] = input.value;
          var available = variants.some(function (v) {
            if (!v.available) return false;
            for (var k = 0; k < test.length; k++) { if (k !== index && test[k] !== null && v.options[k] !== test[k]) return false; }
            return v.options[index] === input.value;
          });
          wrap.classList.toggle('is-unavailable', !available);
        });
        var label = $('[data-option-selected]', fs);
        if (label) label.textContent = opts[index] || '';
      });
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateAvailability(opts);
      var idInput = form ? $('[data-variant-id]', form) : null;
      var button = form ? $('[data-add-button]', form) : null;
      var label = form ? $('[data-add-label]', form) : null;
      var stock = $('[data-stock]', root);
      var price = $('[data-price]', root);

      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = theme.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.innerHTML = variant.price_html;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (stock) {
        stock.classList.remove('product__stock--low', 'product__stock--out');
        var threshold = Number(stock.getAttribute('data-threshold') || 5);
        if (!variant.available) { stock.classList.add('product__stock--out'); stock.textContent = theme.strings.soldOut; }
        else if (variant.inventory !== null && variant.inventory > 0 && variant.inventory <= threshold) {
          stock.classList.add('product__stock--low');
          stock.textContent = (stock.getAttribute('data-low-template') || '__COUNT__').replace('__COUNT__', variant.inventory);
        } else { stock.textContent = stock.getAttribute('data-in-stock') || stock.textContent; }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media_id) {
        var media = $('[data-media-id="' + variant.featured_media_id + '"]', root);
        var gallery = $('[data-gallery]', root);
        if (media && gallery) {
          if (window.matchMedia('(max-width: 749px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else if (gallery.firstElementChild !== media) {
            gallery.insertBefore(media, gallery.firstElementChild);
          }
        }
      }
    }

    if (picker) {
      picker.addEventListener('change', onVariantChange);
      updateAvailability(selectedOptions());
    }

    if (form) {
      var qtyInput = $('input[name="quantity"]', form);
      form.addEventListener('click', function (e) {
        if (!qtyInput) return;
        if (e.target.closest('[data-qty-minus]')) qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
        if (e.target.closest('[data-qty-plus]')) qtyInput.value = Number(qtyInput.value) + 1;
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var button = $('[data-add-button]', form);
        var errorEl = $('[data-form-error]', form);
        var id = Number($('[data-variant-id]', form).value);
        var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
        if (errorEl) errorEl.hidden = true;
        if (button) button.setAttribute('aria-disabled', 'true');
        addToCart([{ id: id, quantity: qty }])
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .then(function () { if (button) button.removeAttribute('aria-disabled'); });
      });
    }

    /* Lightbox */
    var lightbox = $('[data-lightbox]', root);
    if (lightbox) {
      $$('[data-lightbox-index]', root).forEach(function (m) {
        m.addEventListener('click', function () {
          if (window.matchMedia('(max-width: 749px)').matches) return;
          var index = m.getAttribute('data-lightbox-index');
          lightbox.classList.add('is-open');
          document.body.classList.add('is-locked');
          var img = $('[data-lightbox-image="' + index + '"]', lightbox);
          if (img) setTimeout(function () { lightbox.scrollTo({ top: img.offsetTop }); }, 20);
        });
      });
      lightbox.addEventListener('click', function (e) { if (e.target.closest('[data-lightbox-close]') || e.target.tagName === 'IMG') closeLightbox(); });
    }
  }

  function closeLightbox() {
    var lb = $('[data-lightbox].is-open');
    if (!lb) return;
    lb.classList.remove('is-open');
    if (!activeDrawer) document.body.classList.remove('is-locked');
  }

  /* ------------------------------------------------------------------
     Collection / search filters
     ------------------------------------------------------------------ */
  function renderResults(url, push) {
    var container = $('[data-results-container]');
    if (!container) { window.location.href = url; return; }
    var sectionId = sectionIdOf(container);
    var grid = $('[data-results]', container);
    if (grid) grid.classList.add('is-loading');
    var drawerOpen = !!$('#FacetsDrawer.is-open');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-results-container]');
        if (!fresh) { window.location.href = url; return; }
        container.innerHTML = fresh.innerHTML;
        if (push) window.history.pushState({ facets: true }, '', url);
        if (drawerOpen) openDrawer('FacetsDrawer', { instant: true });
        initReveal(container);
      })
      .catch(function () { window.location.href = url; });
  }

  function submitFacets(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) { if (value !== '') params.append(key, value); });
    var sort = document.querySelector('select[name="sort_by"][form="' + form.id + '"]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    renderResults(form.getAttribute('action') + '?' + params.toString(), true);
  }

  var submitFacetsDebounced = debounce(submitFacets, 450);

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-facet-input]');
    if (!input) return;
    var form = input.form || input.closest('form');
    if (!form) return;
    if (input.type === 'number') submitFacetsDebounced(form); else submitFacets(form);
  });
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-facet-input][type="number"]');
    if (input && input.form) submitFacetsDebounced(input.form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (form) { e.preventDefault(); submitFacets(form); }
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facet-link]');
    if (link) { e.preventDefault(); renderResults(link.getAttribute('href'), true); }
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.facets) renderResults(window.location.href, false);
  });

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.querySelector('.product-grid')) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; initReveal(el); }
      }).catch(function () {});
    });
  }

  /* ------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------ */
  var revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function initReveal(ctx) {
    $$('.reveal:not(.is-visible)', ctx).forEach(function (el, i) {
      if (!revealObserver) { el.classList.add('is-visible'); return; }
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Newsletter popup
     ------------------------------------------------------------------ */
  var POPUP_KEY = 'bearfit-popup-dismissed';
  function closePopup() {
    var popup = $('[data-popup].is-open');
    if (!popup) return;
    popup.classList.remove('is-open');
    storage.set(POPUP_KEY, String(Date.now()));
  }
  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup) return;
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-popup-close]')) closePopup();
    });
    var posted = window.location.search.indexOf('customer_posted=true') > -1 && window.location.hash.indexOf('PopupNewsletter') > -1;
    if (posted) { popup.classList.add('is-open'); return; }
    if (popup.getAttribute('data-design-mode') === 'true') return;
    var dismissed = Number(storage.get(POPUP_KEY) || 0);
    if (dismissed && Date.now() - dismissed < 1000 * 60 * 60 * 24 * 14) return;
    var delay = Number(popup.getAttribute('data-delay') || 8) * 1000;
    setTimeout(function () { if (!activeDrawer) popup.classList.add('is-open'); }, delay);
  }


  /* ------------------------------------------------------------------
     Announcement rotator
     ------------------------------------------------------------------ */
  function initRotators(ctx) {
    $$('[data-rotator]', ctx).forEach(function (rot) {
      if (rot._timer) clearInterval(rot._timer);
      var items = $$('[data-rotator-item]', rot);
      if (items.length < 2) return;
      var i = 0;
      var interval = Number(rot.getAttribute('data-interval') || 5) * 1000;
      rot._timer = setInterval(function () {
        if (rot.matches(':hover')) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ------------------------------------------------------------------
     Slideshow
     ------------------------------------------------------------------ */
  function initSlideshows(ctx) {
    $$('[data-slideshow]', ctx).forEach(function (el) {
      if (el._slideshow) el._slideshow.destroy();
      var slides = $$('[data-slide]', el);
      var dots = $$('[data-slide-to]', el);
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      var autoplay = el.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var speed = Number(el.getAttribute('data-speed') || 6) * 1000;

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
        dots.forEach(function (d, i) {
          d.classList.remove('is-active');
          d.classList.toggle('is-done', i < index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        var active = dots[index];
        if (active) { void active.offsetWidth; active.classList.add('is-active'); }
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (autoplay && !el.classList.contains('is-paused')) timer = setTimeout(function () { go(index + 1); }, speed);
      }
      function onClick(e) {
        var to = e.target.closest('[data-slide-to]');
        if (to) { go(Number(to.getAttribute('data-slide-to'))); return; }
        if (e.target.closest('[data-slide-prev]')) go(index - 1);
        if (e.target.closest('[data-slide-next]')) go(index + 1);
      }
      var startX = null;
      function onTouchStart(e) { startX = e.touches[0].clientX; }
      function onTouchEnd(e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      }
      el.addEventListener('click', onClick);
      el.addEventListener('touchstart', onTouchStart, { passive: true });
      el.addEventListener('touchend', onTouchEnd);
      document.addEventListener('visibilitychange', schedule);
      el._slideshow = {
        go: go,
        pause: function () { el.classList.add('is-paused'); clearTimeout(timer); },
        play: function () { el.classList.remove('is-paused'); go(index); },
        destroy: function () { clearTimeout(timer); el.removeEventListener('click', onClick); el.removeEventListener('touchstart', onTouchStart); el.removeEventListener('touchend', onTouchEnd); }
      };
      go(0);
    });
  }

  /* ------------------------------------------------------------------
     Carousels (scroll-snap + arrows)
     ------------------------------------------------------------------ */
  function initCarousels(ctx) {
    $$('[data-carousel-root]', ctx).forEach(function (root) {
      var track = $('[data-carousel-track]', root);
      if (!track || track._carousel) return;
      track._carousel = true;
      var prev = $('[data-carousel-prev]', root);
      var next = $('[data-carousel-next]', root);
      function step() {
        var item = track.querySelector('.carousel-item');
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', debounce(update, 60), { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }

  /* ------------------------------------------------------------------
     Misc
     ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-auto-submit]');
    if (sel && sel.form) sel.form.submit();
  });

  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-copy-link]');
    if (!copy || !navigator.clipboard) return;
    navigator.clipboard.writeText(copy.getAttribute('data-copy-link')).then(function () {
      var old = copy.textContent; copy.textContent = '✓'; setTimeout(function () { copy.textContent = old; }, 1500);
    });
  });

  function fitText() {
    $$('[data-fit-text]').forEach(function (el) {
      var parent = el.parentElement;
      el.style.fontSize = '';
      var available = parent.clientWidth - parseFloat(getComputedStyle(parent).paddingLeft) - parseFloat(getComputedStyle(parent).paddingRight);
      var current = el.scrollWidth;
      if (!current) return;
      var size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * (available / current) * 0.99) + 'px';
    });
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initRotators(e.target);
    initSlideshows(e.target);
    initCarousels(e.target);
    if (e.target.querySelector('[data-header]')) initHeader();
    var product = e.target.querySelector('[data-product-section]');
    if (product) initProduct(product);
    if (e.target.querySelector('[data-popup]')) { var p = e.target.querySelector('[data-popup]'); p.classList.add('is-open'); initPopup(); }
    fitText();
  });
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('[data-popup]');
    if (p) p.classList.add('is-open');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slide]');
    var show = e.target.closest('[data-slideshow]');
    if (slide && show && show._slideshow) { show._slideshow.go(Number(slide.getAttribute('data-slide'))); show._slideshow.pause(); }
    var item = e.target.closest('.carousel-item');
    var track = e.target.closest('[data-carousel-track]');
    if (item && track) track.scrollTo({ left: item.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
    var rot = e.target.closest('[data-rotator]');
    if (rot) { $$('[data-rotator-item]', rot).forEach(function (i) { i.classList.toggle('is-active', i === e.target.closest('[data-rotator-item]')); }); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var show = e.target.closest('[data-slideshow]');
    if (show && show._slideshow) show._slideshow.play();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('[data-popup]');
    if (p) p.classList.remove('is-open');
  });

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  function init() {
    initHeader();
    initPredictiveSearch();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initReveal(document);
    initRotators(document);
    initSlideshows(document);
    initCarousels(document);
    initPopup();
    fitText();
    window.addEventListener('resize', debounce(fitText, 200));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
